<template>
  <v-dialog v-model="dialog" width="600px" persistent>
      <v-card>
            <v-card-title class="pa-1">
                <v-col cols="12" class="pa-0 text-right">
                    <v-btn icon color="primary" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                    <h1 v-if="type">Histórico de eventos</h1>
                    <h1 v-else>Histórico de eventos de <br> pagamento</h1>
                </v-col>
            </v-card-title>
            
            <v-card-text class="py-0">
                <v-row>
                    <v-col v-if="!type" cols="1" class="mr-5"></v-col>
                    <v-col cols="4" class="pl-8 pr-0">
                        <b>Operadora:</b>
                        <div>{{ historico.header? historico.header.oper_nome : "" }}</div>
                    </v-col>
                    <v-col cols="4" class="pl-8 pr-0">
                        <b>Prestador:</b>
                        <div>{{ historico.header? historico.header.prest_nome : "" }}</div>
                    </v-col>
                    <v-col cols="4" class="pl-8 pr-0">
                        <!-- v-if="type"  -->
                        <b>Ident. na Operadora:</b>
                        <div>{{ historico.header? historico.header.identificador_prestador : "" }}</div>
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <v-data-table dense :headers="headers" :items="historico.list" hide-default-footer>
                            <template v-slot:item="props">
                                <tr>
                                    <td>
                                        {{props.item.data_evento | formatDateHour}}
                                    </td>
                                    <!-- <td>
                                        <span v-if="!props.item.erro"> {{props.item.evento}} </span>
                                        <span v-else style="color:#D0021B">{{props.item.evento}}</span>
                                    </td> -->
                                    <td>
                                        <span v-if="!props.item.erro"> {{props.item.mensagem}} </span>
                                        <span v-else style="color:#D0021B"> {{props.item.mensagem}}  </span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions class="justify-center py-5">
                <v-btn
                    color="primary"
                    height="30px"
                    small
                    depressed
                    @click="close()"
                >Fechar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {
    data() {
        return {
            headers: [
                { text: "Data do evento", value: "date_evento", sortable: false },
                { text: "Evento", value: "evento", sortable: false },
                // { text: "Mensagem", value: "evento", sortable: false },
            ],
        }
    },
    filters: {
        formatDateHour(date) {
            return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h' 
        },
    },
    props: {
        dialog: Boolean,
        close: Function,
        historico: Object,
        type: Boolean
    }
}
</script>

<style>

</style>